<div class="modal-header">
  <h5 class="modal-title">Compliances Info</h5>
  <button
    type="button"
    class="btn-close custom-btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose()"
  >
    <i class="ti ti-x"></i>
  </button>
</div>
<div class="modal-body">
  <table class="table datatable">
    <thead class="thead-light">
      <tr>
        <th scope="col">Compliance</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let compliance of compliancesListEntries">
        <td>{{ compliance[0] }}</td>
        <td><i [ngClass]="compliance[1] ? 'ti ti-checks' : 'ti ti-x'"></i></td>
      </tr>
    </tbody>
  </table>
</div>
